module.exports = __webpack_public_path__ + "static/media/bureau.168250d1.png";